import Modal from "@/components/shared-ui/Modal";
import * as Styled from "./styled";
import type {
  RoadmapItemLongTerm,
  RoadmapItemShortTerm,
} from "@/services/api/types";
import Button from "@/components/shared-ui/Button";
import { statusDescriptions } from "../statusColors";

type Props = {
  item: RoadmapItemShortTerm | RoadmapItemLongTerm;
  modalActive: boolean;
  toggleModal: () => void;
};

const DetailsModal = ({ item, modalActive, toggleModal }: Props) => {
  const isShortTermItem = (
    roadmapItem: RoadmapItemShortTerm | RoadmapItemLongTerm,
  ): roadmapItem is RoadmapItemShortTerm => "itemStatus" in roadmapItem;

  const statusLabel =
    isShortTermItem(item) && item.itemStatus
      ? item.itemStatus
          .split("_")
          .join(" ")
          .replace(/^\w/, (char) => char.toUpperCase())
      : null;

  const updateLink =
    isShortTermItem(item) && item.changeReleaseNote
      ? `/updates/${item.changeReleaseNote.slug}`
      : undefined;

  const releaseNoteLink =
    isShortTermItem(item) && item.releaseNote
      ? `/updates/${item.releaseNote.slug}`
      : undefined;

  return (
    <Modal
      modalActive={modalActive}
      toggleModal={toggleModal}
      customWidth="900px"
    >
      <Styled.ModalContent>
        <h2>{item.name}</h2>
        {isShortTermItem(item) && statusLabel && (
          <Styled.ModalStatus $status={item.itemStatus}>
            {statusLabel}
            <Styled.StatusTooltip $position="right">
              {statusDescriptions[item.itemStatus]}
            </Styled.StatusTooltip>
          </Styled.ModalStatus>
        )}
        {item.itemDetails && <pre>{item.itemDetails}</pre>}
        {isShortTermItem(item) && item.productSpecificationDocUrl && (
          <a
            href={item.productSpecificationDocUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              type="button"
              label="See product specification document"
              variant="tertiary"
            />
          </a>
        )}
        {releaseNoteLink && (
          <Button
            variant="tertiary"
            internalLink={releaseNoteLink}
            label="See the release note"
          />
        )}
        {isShortTermItem(item) && item.changeDescription && (
          <Styled.WhatsChanged>
            <h4>{item.changeHeading}</h4>
            <pre>{item.changeDescription}</pre>
            {updateLink && (
              <Button
                variant="tertiary"
                internalLink={updateLink}
                label="Find out more"
              />
            )}
          </Styled.WhatsChanged>
        )}
      </Styled.ModalContent>
    </Modal>
  );
};

export default DetailsModal;
